import React from 'react';
import { Modal, Button, InputNumber, Table, Tag, Spin, Icon } from 'antd';
import { openNotification } from '../../util/notificaciones';
import Pedidos from '../../services/Pedidos';
import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

export default class RecibirPedidoRealizado extends React.Component {
    state = {
        mostrarModalConfirm: false,
        rowDelete: null,
        articulosPedido: [],
        cargando: false,
        bloquearBtn: false,
        objArticuloCambio: null,
        mostrarModalCambio: false,
        cargandoCambio: false,
        proveedoresAdSitio: [],
        infoTablaCambio: [],
        selectedRowKeys: [],
        selectedRows: [],
        disableBtnCambio: true,
        mostrarConfirmacioneliminar: false,
        articuloCambioSelected: null,
        disableBtnContinuar: false,
        pedido_selected: null,
        bloquearAtras: false,
        objCancelarArticulo: null,
        bloquearBtnRecibir: true,
        mostrarModalCodigos: false,
        paginas_vistas: [1],
        paginas_faltantes: [],
        paginaSiguiente: 1,
        paginacion: {},
        mostrarModalHijos: false,
        arrCodigosHijos: [],
        paginas_totales: 0,
        total_articulos: [],
        pagina_actual: 1,
        disableBtnHijos: false,
        artNoEmbarcados: [],
    };

    componentDidUpdate = (prevProps) => {
        let state = { ...this.state };
        if (this.props.pedido_selected !== prevProps.pedido_selected) {
            if (this.props.tipo_modal === 'Recibir') {
                if (this.props.pedido_selected !== null) {
                    state.articulosPedido = [];
                    state.cargando = true;
                    state.artNoEmbarcados = [];
                    state.bloquearBtnRecibir = true;
                    state.paginaSiguiente = 1;
                    state.pagina_actual = 1;
                    state.total_articulos = [];
                    state.arrCodigosHijos = [];
                    state.paginas_vistas = [1];

                    this.setState(state, () => {
                        this.cargarPaginaArticulos(1);
                    });
                }
            }
        }
    };

    cargarPaginaArticulos = (numeroPagina) => { // 'numeroPagina' ya no será tan relevante aquí si no hay paginación, pero lo mantendremos para la consistencia de la llamada.
        let state = { ...this.state };
        state.cargando = true;
    
        this.setState(state, () => {
            Pedidos.CargarArticulosPedidoPag(
                this.props.pedido_selected.id,
                undefined, // No enviamos 'page' ya que no hay paginación
                true,      // Mantener 'recibir' como 'true'
                0          // ¡Aquí le decimos al backend que no pagine, devolviendo todos los resultados!
            )
                .then((response) => {
                    // Confirmamos que la data viene directamente en 'results'
                    const newState = { ...this.state };
                    newState.cargando = false;

                    
                    const articulosCompletos = response.data.map( // <-- ¡IMPORTANTE: .results aquí!
                        (item) => {
                            let newItem = { ...item };
                            newItem.esEditable = false;
                            newItem.disabled = false;
                            newItem.bordeRojo = false;
    
                            if (newItem.status === 'Embarcado' || newItem.status === 'Pendiente') {
                                newItem.cantidad_recibida = newItem.cantidad_embarcada;
                                newItem.cantidad_original = newItem.cantidad_solicitada;
                                newItem.esEditable = true;
                                if (item.cant_disp_encabezado === 0) {
                                    newItem.disabled = true;
                                    newItem.cantidad_recibida = 0;
                                    newItem.esEditable = false;
                                }
                            } else if (newItem.status === '' || newItem.status === null) {
                                newItem.cantidad_recibida = 0;
                                newItem.cantidad_original = newItem.cantidad_solicitada;
                                newItem.status = 'No Embarcado';
                                newState.artNoEmbarcados.push(newItem);
                            } else {
                                newItem.cantidad_recibida = newItem.cantidad_recibida_prev || 0;
                            }
                            return newItem;
                        }
                    );
    
                    articulosCompletos.sort((a, b) => {
                        const proveedorA = String(a.codigo_proveedor);
                        const proveedorB = String(b.codigo_proveedor);
                        if (proveedorA < proveedorB) return -1;
                        if (proveedorA > proveedorB) return 1;
                        const deliveryA = a.delivery ? String(a.delivery) : '';
                        const deliveryB = b.delivery ? String(b.delivery) : '';
                        return deliveryA.localeCompare(deliveryB);
                    });
    
                    const itemsConHeaders = this.handleHeaderArticles(articulosCompletos);
    
                    const itemsParaTablaRecibir = itemsConHeaders.filter((item) => {
                        return (
                            item.isHeader ||
                            item.status === 'Embarcado' ||
                            item.status === 'Pendiente'
                        );
                    });
    
                    newState.articulosPedido = itemsParaTablaRecibir;
    
    
    
                    newState.bloquearBtnRecibir = !itemsParaTablaRecibir.some(item => !item.isHeader && item.esEditable && !item.disabled);
    

                    this.setState(newState);
                })
                .catch((err) => {
                    console.error("Error al cargar artículos del pedido:", err.response || err);
                    this.setState({ cargando: false, bloquearBtnRecibir: true });
                    openNotification(
                        'No se han podido cargar los artículos del pedido.',
                        'Error al cargar artículos',
                        false
                    );
                });
        });
    };

    handleHeaderArticles = (articulos) => {
        const renderItems = [];
        let lastCodigoProveedor = null;
    
        const subtotalesPorProveedor = {};
        articulos.forEach(item => {
            if (!item.isHeader && (item.status === 'Embarcado' || item.status === 'Pendiente')) {
                const currentReceived = item.cantidad_recibida !== undefined && item.cantidad_recibida !== null ? item.cantidad_recibida : 0;
                if (subtotalesPorProveedor[item.codigo_proveedor]) {
                    subtotalesPorProveedor[item.codigo_proveedor] += currentReceived;
                } else {
                    subtotalesPorProveedor[item.codigo_proveedor] = currentReceived;
                }
            }
        });
    
        articulos.forEach((item) => {
            const isSameProveedor = lastCodigoProveedor === item.codigo_proveedor;
    
            if (!isSameProveedor) {
                renderItems.push({
                    id: `header-${String(item.codigo_proveedor)}`,
                    codigo_proveedor: item.codigo_proveedor,
                    descripcion_articulo: item.descripcion_articulo, 
                    cantidad_solicitada: item.cantidad_solicitada, 
                    isHeader: true,
                    rowClass: 'header-row',
                    subtotal_recibida: subtotalesPorProveedor[item.codigo_proveedor] || 0, 
                    status: null,
                    unidad_medida: null,
                    cantidad_recibida_prev: null,
                    cantidad_embarcada: null,
                    delivery: null,
                });
                lastCodigoProveedor = item.codigo_proveedor;
            }
    
            renderItems.push({
                ...item,
                rowClass: isSameProveedor ? 'same-provider' : 'new-provider',
                isHeader: false,
            });
        });
    
        return renderItems;
    };

    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };

        if (state.pagina_actual !== paginaSiguiente) { // Evitar recargar la misma página
             // Guardar cambios de la página actual antes de cambiar
            state.total_articulos[state.pagina_actual - 1] = [...state.articulosPedido];

            state.paginaSiguiente = paginaSiguiente;
            this.setState(state, () => {
                if (this.state.total_articulos[paginaSiguiente - 1]) {
                    const newState = { ...this.state };
                    newState.pagina_actual = paginaSiguiente;
                    newState.articulosPedido = [...this.state.total_articulos[paginaSiguiente - 1]];
                    newState.paginacion = { ...newState.paginacion, current: paginaSiguiente };
                    newState.bloquearBtnRecibir = !newState.articulosPedido.some(item => !item.isHeader && item.esEditable && !item.disabled);
                    if (!newState.paginas_vistas.includes(paginaSiguiente)) {
                        newState.paginas_vistas.push(paginaSiguiente);
                    }
                    this.setState(newState);
                } else {
                    this.cargarPaginaArticulos(paginaSiguiente);
                }
            });
        }
    };


    handleCancel = () => {
        let state = { ...this.state };
        state.bloquearBtnRecibir = true;
        state.total_articulos = [];
        state.arrCodigosHijos = [];
        state.pagina_actual = 1;
        state.paginaSiguiente = 1;
        state.paginas_vistas = [1];
        state.articulosPedido = [];
        state.cargando = false;
        this.setState(state);
        this.props.esconderModal();
    };

    cancelModalConfirm = () => {
        this.setState({ mostrarModalConfirm: false, rowDelete: null });
    };

    showModalConfirm = (record) => {
        this.setState({ mostrarModalConfirm: true, rowDelete: record });
    };

    eliminarArticulo = () => {
        let state = { ...this.state };
        state.bloquearBtn = true;
        this.setState(state, () => {
            Pedidos.CancelarArticuloPedido(state.objCancelarArticulo.id)
                .then((response) => {
                    this.cargarPaginaArticulos(this.state.pagina_actual);
                    openNotification(
                        'Se ha eliminado el artículo del pedido correctamente.',
                        'Artículo eliminado correctamente',
                        true
                    );
                    this.setState({
                        mostrarConfirmacioneliminar: false,
                        bloquearBtn: false,
                        objCancelarArticulo: null, // Limpiar el objeto a cancelar
                    });
                })
                .catch((err) => {
                    this.setState({
                        bloquearBtn: false,
                        mostrarConfirmacioneliminar: false,
                    });
                    openNotification(
                        'No se ha podido eliminar el artículo del pedido.',
                        'Error al eliminar artículo',
                        false
                    );
                });
        });
    };

    onChangeCantArticulo = (value, record) => {
        let newValue = value === '' || value === undefined || value === null ? 0 : value; // Mantener el valor original inicialmente

        const soloNumeros = String(newValue).replace(/[^0-9]/g, '');

        newValue = soloNumeros === '' ? 0 : Number(soloNumeros);

        if (newValue < 0) {
            newValue = 0;
        }

        const recordKey = `detail-${record.id}-${record.delivery}`;
        const maxPermitido = ["Barista"].includes(localStorage.getItem("role")) ? record.cantidad_solicitada : record.cantidad_embarcada;
        const esValido = newValue >= 0 && newValue <= maxPermitido;

        let hijoModificado = false;
        const hijoParentKey = recordKey;
        let newArrCodigosHijos = [...this.state.arrCodigosHijos];

        const newArticulosPedido = this.state.articulosPedido.map((item) => {
            if (!item.isHeader && item.id === record.id && item.delivery === record.delivery) {
                const esParcialAhora = esValido && newValue > 0 && newValue < maxPermitido;
                const eraParcialAntes = item.parcialAdded === true;

                const hijoExistenteIndex = newArrCodigosHijos.findIndex(h => h.parentId === hijoParentKey);
                const cantidadFaltante = maxPermitido - newValue;

                if (esParcialAhora) {
                    const hijoData = {
                        id: `hijo-${hijoParentKey}`,
                        parentId: hijoParentKey, 
                        codigo_proveedor: record.codigo_proveedor,
                        descripcion_articulo: record.descripcion_articulo,
                        unidad_medida: record.unidad_medida,
                        delivery: record.delivery, 
                        status: 'Pendiente',
                        cantidad: cantidadFaltante, 
                    };

                    if (hijoExistenteIndex > -1) {
                        if (newArrCodigosHijos[hijoExistenteIndex].cantidad !== cantidadFaltante) {
                            newArrCodigosHijos[hijoExistenteIndex] = { ...newArrCodigosHijos[hijoExistenteIndex], cantidad: cantidadFaltante };
                            hijoModificado = true;
                        }
                    } else {
                        newArrCodigosHijos.push(hijoData);
                        hijoModificado = true;
                    }
                } else if (eraParcialAntes && hijoExistenteIndex > -1) {
                    newArrCodigosHijos = newArrCodigosHijos.filter(h => h.parentId !== hijoParentKey);
                    hijoModificado = true;
                }
                // --- Fin Lógica Hijos ---

                // Retornar item actualizado
                return {
                    ...item,
                    cantidad_recibida: newValue,
                    bordeRojo: !esValido,
                    parcialAdded: esParcialAhora,
                };
            }
            // Retornar otros items sin cambios
            return item;
        });

        const itemOriginal = this.state.articulosPedido.find(a => !a.isHeader && a.id === record.id && a.delivery === record.delivery);
        const huboCambioValor = itemOriginal?.cantidad_recibida !== newValue;
        const huboCambioBorde = itemOriginal?.bordeRojo !== !esValido;

        if (hijoModificado || huboCambioValor || huboCambioBorde) {
            this.setState({
                articulosPedido: newArticulosPedido,
                arrCodigosHijos: newArrCodigosHijos,
            }, () => {
                const codigoProveedor = record.codigo_proveedor;
                let nuevoSubtotal = 0;
                this.state.articulosPedido.forEach(item => {
                    if (!item.isHeader && item.codigo_proveedor === codigoProveedor && typeof item.cantidad_recibida === 'number') {
                        nuevoSubtotal += item.cantidad_recibida;
                    }
                });

                const updatedArticulosPedido = this.state.articulosPedido.map(item => {
                    if (item.isHeader && item.codigo_proveedor === codigoProveedor) {
                        return { ...item, subtotal_recibida: nuevoSubtotal };
                    }
                    return item;
                });

                this.setState({ articulosPedido: updatedArticulosPedido });
            });
        }
    };

    mostrarConfirmacionRecibir = () => {
        let state = { ...this.state };

        state.total_articulos[state.pagina_actual - 1] = [...state.articulosPedido];

        let count_pages = Math.ceil(state.paginas_totales / 10);
        let total_pages_array = Array.from({ length: count_pages }, (_, i) => i + 1);
        let pag_vistas_set = new Set(state.paginas_vistas);
        let vistas_faltantes = total_pages_array.filter(x => !pag_vistas_set.has(x));

        if (vistas_faltantes.length > 0) {
            let message_var = vistas_faltantes.length === 1 ? 'la siguiente página:' : 'las siguientes páginas:';
            openNotification(
                `Para continuar con la recepción del pedido, deberá revisar ${message_var} ${vistas_faltantes.join(', ')}`,
                'Aviso: Páginas Pendientes',
                false
            );
            this.setState({ total_articulos: state.total_articulos });
            return;
        }

        if (state.arrCodigosHijos.length > 0) {
            state.mostrarModalHijos = true;
            this.setState(state);
        } else {
            this.recibirPedido();
        }
    };

    recibirPedido = () => {
        let state = { ...this.state };
        let articulos_recibidos = [];
        let articulos_pendientes = [...state.arrCodigosHijos];
        let articulos_cantidad_cero = [];
        let articulos_adicionales = [];
        let objEnviar = {};
        let articulos_procesados_completos = [];

        state.total_articulos.forEach(pagina => {
             if(pagina) {
                 pagina.forEach(item => {
                      if (!item.isHeader) {
                          articulos_procesados_completos.push(item);
                      }
                 });
             }
        });

        for (const element of articulos_procesados_completos) {
             const esPadreConHijo = element.parcialAdded === true;

             if (element.cantidad_recibida > 0 && (element.status === 'Embarcado' || element.status === 'Pendiente')) {
                  // Enviar el padre (incluso si es parcial) con la cantidad que realmente se recibió
                  articulos_recibidos.push(element);
             }

             if (element.cantidad_recibida === 0 && (element.status === 'Embarcado' || element.status === 'Pendiente') && !esPadreConHijo) {
                  articulos_cantidad_cero.push(element);
             }

             if (element.cantidad_recibida > element.cantidad_embarcada) {
                  const adicional = { ...element }; // Clonar para no afectar el original
                  adicional.cantidad_adicional = adicional.cantidad_recibida - adicional.cantidad_embarcada;
                  // Opcional: Ajustar la cantidad recibida a enviar si el backend no maneja > embarcada
                  // adicional.cantidad_recibida = adicional.cantidad_embarcada;
                  articulos_adicionales.push(adicional);
                  // Necesitas decidir si el 'element' original también va en articulos_recibidos en este caso
             }
        }

        objEnviar.pedido = this.props.pedido_selected.id;
        objEnviar.articulos_recibidos = articulos_recibidos;
        objEnviar.articulos_pendientes = articulos_pendientes;
        objEnviar.articulos_cantidad_cero = articulos_cantidad_cero;
        objEnviar.articulos_adicionales = articulos_adicionales;
        objEnviar.articulos_no_embarcados = state.artNoEmbarcados;
        objEnviar.psd = true;

        state.bloquearBtnRecibir = true;
        state.cargando = true;
        state.mostrarModalHijos = false;
        state.disableBtnHijos = false;

        this.setState(state, () => {
            Pedidos.RecibirPedido(objEnviar)
                .then((response) => {
                    const finalState = { ...this.state };
                    finalState.total_articulos = [];
                    finalState.arrCodigosHijos = [];
                    finalState.pagina_actual = 1;
                    finalState.paginaSiguiente = 1;
                    finalState.paginas_vistas = [1];
                    finalState.articulosPedido = [];
                    finalState.cargando = false;
                    finalState.bloquearBtnRecibir = true; // Bloquear después de recibir exitosamente? O permitir seguir?
                    this.setState(finalState);

                    this.props.recepcion(response.data);
                    openNotification(
                        response?.data?.cuerpo || 'Pedido recibido con éxito.',
                        response?.data?.titulo || 'Recepción Exitosa',
                        true
                    );
                })
                .catch((err) => {
                     console.error("Error al recibir pedido:", err.response || err);
                    this.setState({ bloquearBtnRecibir: false, cargando: false });
                    openNotification(
                        err?.response?.data?.cuerpo || 'Ocurrió un error al procesar la recepción.',
                        err?.response?.data?.titulo || 'Error en Recepción',
                        false
                    );
                });
        });
    };

    render() {
        const columnasArticulos = [
            {
                title: 'Código',
                dataIndex: 'codigo_proveedor',
                key: 'codigo_proveedor',
                // Render condicional si necesitas diferente ancho o estilo en header
                 render: (text, record) => record.isHeader ? <strong>{text}</strong> : text
            },
            {
                title: 'Descripción',
                dataIndex: 'descripcion_articulo',
                key: 'descripcion_articulo',
                 render: (text, record) => record.isHeader ? <strong>{text}</strong> : text
            },
            {
                title: 'Estatus',
                dataIndex: 'status',
                key: 'status',
                render: (estatus, record) => {
                    if (record.isHeader) return null;
                    return (                     <Tag
                        color={estatus === "Abierto" ? "#6fa8dcff" : estatus === "Terminado" ? "#092f50" : estatus === "Pendiente" ? "#d8b000" : estatus === "Planeado" ? "#3d85c6ff" : estatus === "Embarcado" ? "#0b5394ff" : ''}
                        key={estatus}>
                        {estatus}
                    </Tag> );
                },
            },
            {
                title: 'UDMP',
                dataIndex: 'unidad_medida',
                key: 'unidad_medida',
                render: (text, record) => (record.isHeader ? null : text),
            },
            {
                title: 'Cant. Solicitada',
                dataIndex: 'cantidad_solicitada',
                key: 'cantidad_solicitada',
                render: (text, record) => (record.isHeader ? text : null),
            },
            {
                title: 'Cant. Recibida Prev.',
                dataIndex: 'cantidad_recibida_prev',
                key: 'cantidad_recibida_prev',
                render: (text, record) => (record.isHeader ? null : text),
            },
            {
                title: 'Cant. Embarcada',
                dataIndex: 'cantidad_embarcada',
                key: 'cantidad_embarcada',
                render: (text, record) => (record.isHeader ? null : text),
            },
            {
                 title: "Codigo Embarque",
                 dataIndex: "deliveryReception",
                 key: "deliveryReception",
                 render: (text, record) => (record.isHeader ? null : text),
            },
            {
                title: 'Cant. recibida',
                dataIndex: 'cantidad_recibida',
                key: 'cantidad_recibida',
                render: (value, record) => {
                    if (record.isHeader) {
                        return (
                            <div style={{ fontWeight: 'bold' }}>
                                {record.subtotal_recibida !== undefined ? `${record.subtotal_recibida}` : ''}
                            </div>
                        );
                    } else {
                        return (
                            <>
                                <InputNumber
                                    type="number"
                                    formatter={val => String(val).replace(/[,.-]$/, '')}
                                    parser={val => String(val).replace(/[,.-]$/, '')}
                                    min={0}
                                    max={ ["Barista"].includes(localStorage.getItem("role")) ? record.cantidad_solicitada : record.cantidad_embarcada}
                                    maxLength={7}
                                    onWheel={(e) => e.target.blur()}
                                    className={record.bordeRojo ? 'bordeRojoInput' : ''}
                                    disabled={record.disabled || !record.esEditable}
                                    onChange={(cant) => { this.onChangeCantArticulo(cant, record); }}
                                    value={value}
                                />
                                {record.bordeRojo && (
                                    <span style={{ color: 'red' }}><br /><small>* Cant. inválida</small></span>
                                )}
                            </>
                        );
                    }
                },
            },
        ];

        const columnasHijos = [
             { title: "Código", dataIndex: "codigo_proveedor", key: "codigo_proveedor" },
             { title: "Descripción", dataIndex: "descripcion_articulo", key: "descripcion_articulo" },
             { title: "Cantidad Pendiente", dataIndex: "cantidad", key: "cantidad" },
             { title: "Codigo Embarque", dataIndex: "delivery", key: "delivery" },
             { title: "UDMP", dataIndex: "unidad_medida", key: "unidad_medida" }
        ];

        return (
            <div>
                <style>{`
                    .header-row { font-weight: bold; background-color:rgba(183, 183, 183, 0.45); }
                    .detail-row { background-color:rgb(254, 254, 254); }
                    .bordeRojoInput { border-color: red !important; }
                `}</style>
                <Modal
                    title={ this.props.pedido_selected !== null ? 'Recepción de pedido número #' + this.props.pedido_selected.pedido_sap : '' }
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={'85%'}
                    maskClosable={false}
                    centered={true}
                    footer={[
                        <Button className="btnCancelar" key="back" onClick={this.handleCancel}>Regresar</Button>,
                        <Button className="btnVerCrearGuardar" key="submit" type="primary"
                            disabled={this.state.bloquearBtnRecibir || this.state.cargando}
                            onClick={this.mostrarConfirmacionRecibir}
                            loading={this.state.cargando && !this.state.bloquearBtnRecibir}
                        >Recibir</Button>,
                    ]}
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: '#e0cbae' }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: '#e0cbae', backgroundColor: 'rgb(255,255,255,0.8)' }}
                    >
                        <Table
                            size="small"
                            pagination={false}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={(record) => record.isHeader
                                                ? record.id 
                                                : `detail-${record.id}-${record.delivery}` 
                                }                            rowClassName={(record) => record.isHeader ? 'header-row' : 'detail-row'}
                            columns={columnasArticulos}
                            dataSource={this.state.articulosPedido}

                        />
                    </Spin>
                </Modal>

                <Modal
                    title={<p style={{ textAlign: 'center', marginBottom: 0 }}>Confirmar Recepción Parcial</p>}
                    onCancel={() => { this.setState({ mostrarModalHijos: false }); }}
                    centered={true}
                    width={'60%'}
                    visible={this.state.mostrarModalHijos}
                    maskClosable={false}
                    footer={[
                        <Button className="btnCancelar" key="back" onClick={() => { this.setState({ mostrarModalHijos: false, disableBtnHijos: false }); }}>Regresar</Button>,
                        <Button className="btnVerCrearGuardar" key="submit" type="primary"
                            disabled={this.state.disableBtnHijos}
                            loading={this.state.disableBtnHijos}
                            onClick={() => { this.setState({ disableBtnHijos: true }, this.recibirPedido); }}>
                            Confirmar y Recibir
                        </Button>,
                    ]}
                >
                    <p style={{ textAlign: 'center' }}>
                        Los siguientes artículos se están recibiendo con cantidad menor a la embarcada.<br/>
                        Se registrará la cantidad recibida y se mantendrá un pendiente por las cantidades faltantes.
                    </p>
                    <Table
                        size="small"
                        pagination={false}
                        locale={{ emptyText: 'No hay artículos con recepción parcial.' }}
                        rowKey={(record) => record.id}
                        columns={columnasHijos}
                        dataSource={this.state.arrCodigosHijos}
                        scroll={{ y: 600 }}
                    />
                </Modal>

                 <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Confirmación para eliminar artículo</p>}
                    onCancel={() => this.setState({ mostrarConfirmacioneliminar: false })}
                    centered={true}
                    visible={this.state.mostrarConfirmacioneliminar}
                    maskClosable={false}
                    footer={[
                        <Button className="btnCancelar" key="back" onClick={() => this.setState({ mostrarConfirmacioneliminar: false })}>Regresar</Button>,
                        <Button className="btnVerCrearGuardar" key="submit" type="primary"
                            disabled={this.state.bloquearBtn}
                            onClick={this.eliminarArticulo}
                        >Continuar</Button>
                    ]}
                 >
                     <p style={{ textAlign: "center" }}>
                         Se va a eliminar el producto {this.state.objCancelarArticulo?.descripcion_articulo || ""} del pedido. ¿Desea continuar?
                     </p>
                 </Modal>
            </div>
        );
    }
}